import { useRef } from "react";
import {
  AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay, Button,
} from "@chakra-ui/react";

interface ConfirmCancelTicketDialogProps {
  isOpen: boolean;
  onClose: () => void;
  ticketId: number | null;
  isCancelling: boolean;
  onConfirm: () => void;
}

export const ConfirmCancelTicketDialog = ({
  isOpen, onClose, ticketId, isCancelling, onConfirm,
}: ConfirmCancelTicketDialogProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="md" fontWeight="bold">Cancelar ticket</AlertDialogHeader>
          <AlertDialogBody fontSize="sm">
            Tem certeza que deseja cancelar o ticket{" "}
            <strong>#{ticketId}</strong> no Freshdesk? Essa ação não pode ser desfeita.
          </AlertDialogBody>
          <AlertDialogFooter gap={2}>
            <Button ref={cancelRef} variant="ghost" size="sm" onClick={onClose}>Voltar</Button>
            <Button
              colorScheme="red" size="sm"
              isLoading={isCancelling} loadingText="Cancelando..."
              onClick={async () => { onClose(); onConfirm(); }}
            >
              Sim, cancelar ticket
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
